<script lang="ts">
  import PixelAvatar from './PixelAvatar.svelte';

  interface Props {
    name: string;
    avatarId: number;
    player: 1 | 2;
    level?: number;
    score?: number;
    hp?: number;
    status?: string;
    state?: 'normal' | 'active' | 'attacking' | 'hurt' | 'empty';
    impactDamage?: number;
  }

  let {
    name,
    avatarId,
    player,
    level = 1,
    score = 0,
    hp = 100,
    status,
    state = 'normal',
    impactDamage,
  }: Props = $props();

  const safeName = $derived(name.slice(0, 10));
  const filled = $derived(Math.round((Math.min(100, Math.max(0, hp)) / 100) * 9));
  const tone = $derived(player === 1 ? 'p1' : 'p2');
  const avatarState = $derived(
    state === 'hurt'
      ? 'hit'
      : state === 'empty'
        ? 'empty'
        : state === 'active'
          ? 'active'
          : 'normal',
  );
</script>

<section
  class="pnJ {tone} {state === 'attacking' ? 'attacking' : ''} {state === 'hurt'
    ? 'hurt'
    : ''} {state === 'empty' ? 'empty' : ''}"
  data-player-status={status ?? `P${player}`}
>
  <div class="rowA">
    <PixelAvatar {avatarId} size="game" {tone} state={avatarState} label={safeName} />
    <span class="nmJ">{state === 'empty' ? '- - - -' : safeName}</span>
  </div>
  <div class="rowB">
    <span class="lvJ">LV.{String(level).padStart(2, '0')}·{status ?? `P${player}`}</span>
    <span class="scJ"
      >{state === 'hurt' && impactDamage
        ? `-${impactDamage}`
        : String(score).padStart(5, '0').slice(-6)}</span
    >
  </div>
  <div
    class="hpJ"
    role="meter"
    aria-label={`Vida de ${safeName}`}
    aria-valuenow={hp}
    aria-valuemin="0"
    aria-valuemax="100"
  >
    {#each { length: 9 } as _, index (index)}
      <i
        class:index-filled={index < filled}
        class:g={index < filled && player === 1}
        class:r={index < filled && player === 2}
      ></i>
    {/each}
  </div>
</section>
